module.exports = __webpack_public_path__ + "img/drag-to-answer-white.7ad65738.png";